import React from 'react';
import { useTranslation } from 'react-i18next';
import EventCard from '../../components/EventCard/EventCard';
import './EventsPage.css';
import { Programs as ProgramsEN } from './../../data/programs';
import { Programs as ProgramsRU } from './../../data/ruprograms';

const EventsPage: React.FC = () => {
  const { t, i18n } = useTranslation();

  // ✅ Select the correct events data based on the current language
  const Programs = i18n.language === 'ru' ? ProgramsRU : ProgramsEN;

  // ✅ Extract all events and include programId
  const allEvents = Programs.flatMap(program =>
    program.events.map(event => ({
      ...event,
      programId: program.id, // Attach program ID for linking
    }))
  );

  // ✅ Sort events by start date (ascending order)
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Normalize time to compare only the date part
  
  const sortedEvents = allEvents
    .filter((event) => {
      const eventDate = new Date(event.dateOfEvent);
      eventDate.setHours(0, 0, 0, 0); // Normalize event date
      return eventDate >= today; // Only keep today or future events
    })
    .sort((a, b) => new Date(a.dateOfEvent).getTime() - new Date(b.dateOfEvent).getTime());
  

  return (
    <div className="events-page">
      <div className="events-page-header">
        <div className="ctitle-container-events">
          <h1 className="events-title">{t("events_title")}</h1>
          <h1 className="events-subtext">{t("events_subtext")}</h1>
        </div>
      </div>

      <div className="events-list">
        {sortedEvents.length > 0 ? (
          sortedEvents.map((event) => (
            <EventCard
              key={event.id}
              eventType={event.eventType}
              master={event.eventMaster}
              image={event.image}
              date={`${event.date} @ ${event.time}`}
              title={event.name} 
              description={event.description || t("no_description")}
              learnMoreLink={`/program/${event.programId}/event/${event.id}`}
              speakersLink={``}  
              locationLink={event.locationLink} 
              location={event.location} 
            />
          ))
        ) : (
          <p>{t("no_events_available")}</p>
        )}
      </div>
    </div>
  );
};

export default EventsPage;
